import clsx from "clsx"
import { useBulkDiscountQuantity } from "src/components/(checkout)/cart/bulkDiscount/state"
import { bulkDiscountBarSteps } from "src/data/products/bulkDiscount"
import { localizeText } from "src/localization/utils"

const steps = bulkDiscountBarSteps

export type BulkDiscountProgressProps = {
  itemsInCart: number
}

export const BulkDiscountProgress = ({ itemsInCart }: BulkDiscountProgressProps) => {
  const quantity = useBulkDiscountQuantity()

  const activeIndex = Math.max(
    0,
    steps.findLastIndex((step) => itemsInCart >= step.count),
  )
  const highlightIndex = Math.max(
    activeIndex,
    steps.findLastIndex((step) => itemsInCart + quantity >= step.count),
  )

  const activeWidth = `${(100 * (activeIndex + 1)) / bulkDiscountBarSteps.length}%`
  const highlightWidth = `${(100 * (highlightIndex + 1)) / steps.length}%`

  const T = localizeText(text)

  return (
    <div className="flex flex-col gap-2 text-center">
      <div className="border-brand-primary relative flex items-center gap-2 overflow-hidden rounded-3xl border bg-white shadow-sm">
        <div
          className="bg-brand-primary/20 absolute inset-0 size-full origin-left rounded-3xl transition-[width] duration-300 ease-out"
          style={{ width: highlightWidth }}
        />

        <div
          className="bg-brand-primary absolute inset-0 size-full origin-left rounded-3xl transition-[width] duration-300 ease-out"
          style={{ width: activeWidth }}
        />

        <div className="z-1 flex w-full">
          {steps.map((step, index) => {
            const filled = activeIndex >= index

            return (
              <div
                key={index}
                className={clsx("flex flex-1 flex-col items-center gap-1 rounded-3xl", {
                  "font-bold text-white": filled,
                  "border-brand-primary-light border-r": filled && index < steps.length - 1,
                })}
              >
                <div className="py-1 text-sm whitespace-nowrap">{step.percent}%</div>
              </div>
            )
          })}
        </div>
      </div>

      <div className="flex gap-2">
        {steps.map((step, index) => (
          <div key={index} className="flex-1 text-xs whitespace-nowrap">
            {T.format_boxCount(step.count)}
          </div>
        ))}
      </div>
    </div>
  )
}

const de = {
  format_boxCount: (count: number) => {
    switch (count) {
      case 1:
        return "1 Box"
      case 2:
      case 3:
        return `${count} Boxen`
      default:
        return "ab 4 Boxen"
    }
  },
}

const en = {
  format_boxCount: (count: number) => {
    switch (count) {
      case 1:
        return "1 box"
      case 2:
      case 3:
        return `${count} boxes`
      default:
        return "4+ boxes"
    }
  },
}

const text = { de, en }
